// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__34Sb9","buttons":"PendingPaymentAlert_buttons__1fpvN"};